/**
 * @readonly
 * @enum {string}
 */
const Type = Object.freeze({
  RUN_SEARCH: 'runSearches',
  GET_RECENT_RECORDS: 'getRecentRecords',
  SET_LAST_RUN_ANALYSIS: 'setLastRunAnalysis',
  SET_LAST_RUN_DASHBOARD: 'setLastRunDashboard',

  // Dashboard
  DELETE_DASHBOARD: 'deleteDashboard',
  GET_ACCESSIBLE_DASHBOARD_INFOS: 'getAccessibleDashboardInfos',
  GET_ACCESSIBLE_TEMPLATE_INFOS: 'getAccessibleDashboardTemplateInfos',
  GET_DASHBOARD: 'getDashboard',
  GET_DASHBOARD_BY_UUID: 'getDashboardByUUID',
  GET_DASHBOARD_FROM_TEMPLATE: 'getNewDashboardFromTemplate',
  SAVE_DASHBOARD: 'saveDashboard',
  UPDATE_DASHBOARD: 'updateDashboard',
  UPDATE_DASHBOARD_ALERTS: 'updateDashboardAlerts',
  UPDATE_LIVE_REPORT_STATUS: 'updateLiveReportStatus',
  SUBSCRIBE_DASHBOARD: 'subscribeDashboard',
  GET_ALL_WIDGET_CONSTRAINTS: 'getAllWidgetConstraints',
  GET_REPORT_INFOS_BY_TOPIC_ID: 'getReportInfosByTopicId',
  GET_REPORT_INFOS_BY_THEME_ID: 'getReportInfosByThemeId',
  GET_DASHBOARD_INFOS_BY_USER: 'getDashboardInfosByUser',
  COPY_DASHBOARD: 'copyDashboard',
  ADVANCED_COPY_DASHBOARD: 'advancedCopyDashboard',
  GET_ACCOUNT_USER_SUGGESTIONS: 'getSuggestedAccountUsers',
  GET_ACCOUNT_USER_SUGGESTIONS_WITH_PERMISSIONS: 'getSuggestedAccountUsersWithExtendPermissions',
  GET_LIVE_REPORT_ID: 'getLiveReportId',
  EXPORT_TO_DASHBOARD: 'exportToDashboard',

  // Analysis
  GET_ANALYSIS: 'getAnalysis',
  SAVE_ANALYSIS: 'saveAnalysis',
  UPDATE_ANALYSIS: 'updateAnalysis',
  GET_ACCESSIBLE_ANALYSIS_INFOS: 'getAccessibleAnalysisInfos',
  GET_ACCESSIBLE_SHARED_ANALYSES: 'getAccessibleSharedAnalyses',
  DELETE_ANALYSIS: 'deleteAnalysis',
  UNSUBSCRIBE_FROM_ANALYSIS: 'unsubscribeFromAnalysis',

  // topic
  GET_ALL_TOPICS: 'getAllTopics',
  GET_TOPIC_INFOS: 'getTopicInfos',
  GET_SHARED_TOPIC: 'getSharedTopic',
  GET_TOPIC_EDIT_LOG: 'getTopicEditLog',
  UPDATE_TOPIC: 'checkAndUpdateTopic',
  UPGRATE_DATA_MODEL: 'upgradeDataModel',
  CREATE_TOPIC: 'checkAndCreateTopic',
  COPY_TOPIC: 'copyTopic',
  ADVANCED_COPY_TOPIC: 'advancedCopyTopic',
  DELETE_TOPIC: 'deleteTopic',
  BUILD_TOPIC: 'buildTopic',
  GET_ALL_ACCESSIBLE_TOPIC_INFOS: 'getAllAccessibleTopicInfos',
  VALIDATE_REBUILD: 'validateRebuild',
  REFORMAT_BOOLEAN_QUERY: 'reformatBooleanQuery',
  GET_TOPIC_FACET_BY_IDS: 'getTopicsFacetByIds',
  ARCHIVE_TOPIC: 'archiveTopic',
  HAS_TOPIC_QUOTA: 'hasTopicQuota',

  // theme
  COPY_THEME: 'copyTheme',
  ADVANCED_COPY_THEME: 'advancedCopyTheme',
  CREATE_SAVE_THEME: 'createSaveTheme',
  DELETE_THEME: 'deleteTheme',
  GET_THEME: 'getTheme',
  GET_ACCESSIBLE_THEME_INFOS: 'getAccessibleThemeInfos',
  GET_ACCESSIBLE_THEME_INFO_BY_ID: 'getAccessibleThemeInfoById',
  GET_THEME_INFOS: 'getThemeInfos',
  UPDATE_THEME: 'updateTheme',
  UPDATE_THEME_INFO: 'updateThemeInfo',
  REFORMAT_THEME_BOOLEAN_QUERY: 'reformatThemeBooleanQuery',
  VALIDATE_CHANNELS: 'validateChannels',

  // export service
  GENERATE_EXCEL: 'generateExcel',
  GENERATE_PNG: 'generatePng',
  GENERATE_PNG_BASE64: 'generatePngBase64',
  GENERATE_PDF: 'generatePDF',
  GENERATE_PRO_PDF: 'generateProPDF',
  GENERATE_SENTENCE_EXCEL: 'generateSentenceExcel',
  GENERATE_DOCUMENT_EXCEL: 'generateDocumentExcel',
  BULK_EXPORT: 'bulkExport',
  GET_AM_AUTHORS_BY_TOPIC: 'getAMAuthorsByTopic',
  GET_AUTHORS_BY_THEME: 'getAuthorsByTheme',
  BULK_AUTHOR_EXPORT: 'bulkAuthorExport',
  BULK_EXPORT_USER_USED_TWEET_QUOTA: 'getUserUsedTweetQuota',
  EXPORT_CATEGORY_INSIGHTS: 'exportCategoryInsights',
  GENERATE_PRO_STREAM_EXCEL: 'generateProStreamExcel',
  GENERATE_PRO_EXCEL: 'generateProExcel',

  // oauth service
  GET_OAUTH_INFO: 'getOAuthInfo',
  CHECK_TOKENS: 'checkTokens',
  REVOKE_OAUTH_PERMISSIONS: 'revokeOAuthPermissions',

  // user event
  LOG_USER_EVENT: 'logJson',

  // Upload
  UPLOAD_IMAGE: 'uploadImage',
  UPLOAD_AUTHORS: 'uploadAuthors',
  UPLOAD_THEME_AUTHORS: 'uploadThemeAuthors',
  UPLOAD_CATEGORY_INSIGHTS: 'uploadCategoryInsights',
  UPLOAD_CHANNELS: 'uploadChannels',
  PROCESS_UPLOADED_CHANNELS: 'processUploadedChannels',

  // Message service
  GET_USER_MESSAGE: 'getUserMessage',
  DISMISS_USER_MESSAGE: 'dismissUserMessage',

  // User Settings
  CHANGE_PASSWORD: 'changePassword',
  CHANGE_LANGUAGE: 'changeLanguage',
  CHANGE_TIMEZONE: 'changeTimeZone',

  // AnalysisTriggered Alert
  ANALYSIS_TRIGGERED_ALERT_TUNE_TEST: 'analysisTriggeredAlertTuneTest',
  ANALYSIS_TRIGGERED_ALERT_BUCKET_DETAIL: 'analysisTriggeredAlertBucketDetail',
  ANALYSIS_TRIGGERED_ALERT_PDF: 'generateAnalysisTriggeredAlertPDF',

  // SAVE Authors
  SAVE_AUTHORS_TO_THEME: 'saveAuthorsToTheme',
  SAVE_AUTHORS_TO_TOPIC: 'saveAuthorsToTopic',

  // Geo
  GEO_GET_SUGGESTIONS: 'getGeoSuggestions',
  GEO_GET_ALL_COUNTRIES: 'getAllCountries',

  // EMOJI
  RETRIEVE_EMOJIS: 'retrieveEmojis',

  // Annotation
  GET_ANNOTATION_TOPIC_INFOS: 'getAnnotationTopicInfos',
  GET_ANNOTATION_TOPIC_BY_TOPIC_ID: 'getAnnotationTopicByTopicId',
  CHECKOUT_DOCUMENTS: 'checkoutDocuments',
  SUBMIT_DOCUMENTS: 'submitDocuments',
  CANCEL_DOCUMENTS: 'cancelDocuments',

  // Admin
  GET_SELLER_COMPANIES: 'getSellerCompanies',
  GET_COMPANIES: 'getCompanies',
  GET_ACCOUNTS: 'getAccounts',
  GET_ACCOUNT_DETAILS: 'getAccountDetails',
  GET_USERS: 'getUsers',
  GET_COMPANY: 'getCompany',
  GET_ACCOUNT: 'getAccount',
  GET_ACCOUNT_WITH_MF: 'getAccountWithMf',
  GET_USER: 'getUser',
  GET_SIQ_ACCESS_TOKEN: 'getSiqAccessToken',
  UPDATE_COMPANY: 'updateCompany',
  UPDATE_USER: 'updateUser',
  UPDATE_USER_SETTING: 'updateUserSetting',
  SAVE_COMPANY: 'saveCompany',
  SAVE_ACCOUNT: 'saveAccount',
  SAVE_USER: 'saveUser',
  DELETE_COMPANY: 'deleteCompany',
  DELETE_ACCOUNT: 'deleteAccount',
  DELETE_USER: 'deleteUser',
  MIGRATE_ASSETS_AND_DELETE_SOURCE_USER: 'migrateAssetsAndDeleteSourceUser',
  MIGRATE_USER_ASSETS: 'migrateAssets',
  GET_USER_ASSETS_SUMMARY: 'GetUserAssetsSummary',
  GET_COMPANY_SUGGESTIONS: 'getSuggestedCompanies',
  GET_ACCOUNT_SUGGESTIONS: 'getSuggestedAccounts',
  GET_USER_SUGGESTIONS: 'getSuggestedUsers',
  GET_PULSES_BY_ACCOUNT: 'getPulseListByAccountId',
  ADD_CATEGORY_INSIGHTS: 'addCategoryInsights',
  UPDATE_CATEGORY_INSIGHTS: 'updateCategoryInsights',
  DELETE_CATEGORY_INSIGHTS: 'deleteCategoryInsights',
  GET_CATEGORY_INSIGHTS_LIST: 'getCategoryInsightsList',
  GET_PULSE_OPTIONS_BY_ACCOUNT: 'getPulseOptionsByAccountId',
  PUT_PULSE: 'putPulse',
  DELETE_PULSE: 'deletePulse',
  MOVE_TOPIC: 'moveTopic',
  QUOTA_SUMMARY_EXPORT: 'quotaSummaryExport',
  RESET_USER_PASSWORD: 'resetUserPassword',
  GET_SYS_MESSAGE: 'getSystemMessage',
  GET_EMBED_PAGE: 'getEmbedPage',
  GET_TIMELINE_ANNOTATION_GROUP: 'getTimelineAnnotationGroup',
  UPDATE_SYS_MESSAGE: 'updateSystemMessage',
  UPDATE_EMBED_PAGE_EVT: 'updateEmbedPageEvent',
  UPDATE_TIMELINE_ANNOTATION: 'updateTimelineAnnotation',
  ADD_TIMELINE_ANNOTATION: 'addTimelineAnnotation',
  DELETE_TIMELINE_ANNOTATION: 'delTimelineAnnotation',
  NEW_SYS_MESSAGE: 'newSystemMessage',
  EXPORT_LOGO_DATA: 'exportLogoData',
  EXPORT_ALL_LOGO_DATA: 'exportAllLogoData',
  EXPORT_ACCOUNT_HASHTAG_DATA: 'exportAccountHashtagData',
  EXPORT_ACCOUNT_AUTHZ_DATA: 'exportAccountAuthzData',
  EXPORT_ACCOUNT_CHANNEL_DATA: 'exportAccountChannelData',

  // Admin tool
  ADMINTOOL_CHECK_DASHBOARD_REPORT: 'adminCheckDashboardReport',

  // Facebook Audience Insights
  FACEBOOK_AUDIENCE_STUDY_LIST: 'getFBStudyList',
  FACEBOOK_AUDIENCE_STUDY_GET: 'getFBStudy',
  FACEBOOK_AUDIENCE_QUERY: 'runFBAudienceQueries',
  FACEBOOK_AUDIENCE_STUDY_CREATE: 'createStudy',
  FACEBOOK_AUDIENCE_STUDY_DELETE: 'deleteStudy',
  FACEBOOK_AUDIENCE_STUDY_PREVIEW: 'previewStudy',
  FACEBOOK_AUDIENCE_FILTER_SUGGESTION: 'getFBFilterSuggestion',

  // CV
  GET_CV_INFO: 'getCVInfos',
  GET_LOGO_SETING_INFOS: 'getLogoSettingInfos',
  GET_LOGO_TYPES: 'getLogoTypes',
  GET_LOGO_TYPE: 'getLogoType',
  GET_LOGO_SETINGS: 'getLogoSettings',
  GET_LOGO_SETING: 'getLogoSetting',
  SAVE_UPDATE_LOGO_TYPE: 'saveUpdateLogoType',
  SAVE_UPDATE_LOGO_SETTING: 'saveUpdateLogoSetting',
  IMPORT_LOGO_DATA: 'importLogoData',

  // Pro
  PRO_CREATE_SEARCH: 'saveProSearch',
  PRO_GET_SEARCH: 'getProSearch',
  PRO_GET_AVAILABLE_SEARCHES: 'getProSearchByUser',
  PRO_UPDATE_SEARCH: 'updateProSearch',
  PRO_DELETE_SEARCH: 'deleteProSearch',
  PRO_GET_SEARCH_BY_TOPIC_ID: 'getProSearchByTopicId',
  PRO_GET_SEARCH_BY_THEME_ID: 'getProSearchByThemeId',
  PRO_GET_TEMPLATE_SHEETS: 'getProAvailableTemplateSheets',
  PRO_GET_SHEET: 'getProSheet',
  PRO_UPDATE_ALERT: 'updateSearchAlerts',
  PRO_BULK_EXPORT: 'proBulkExport',
  PRO_GET_SHARED_LIVE_REPORTS: 'getSharedLiveReports',
  PRO_SET_RECENT_SEARCH: 'setRecentSearch',
  PRO_SET_RECENT_ANALYSIS: 'setRecentAnalysis',
  PRO_GET_LIVE_REPORT_DIRECT_URL: 'getLiveReportDirectUrl',
  PRO_SAW_NEW_HOME: 'sawNewHome',
  PRO_SET_RECENT_LIVE_REPORT: 'setRecentLiveReport',

  // OAuth Token Service
  OAUTH_GENERATE_TOKEN: 'generateAccessToken',
  OAUTH_REVOKE_TOKEN: 'revokeAccessToken',
  OAUTH_GET_TOKEN_LIST: 'getAccessTokenList',
  GET_TOKEN_PROVIDERS: 'getCurrentAccountTokenProviders',
  CREATE_TOKEN_DONATOR: 'createTokenDonator',
  REQUEST_PROVIDE_TOKEN: 'requestProvideToken',
  REVOKE_AND_DELETE_TOKEN: 'revokeAndDeleteTokenById',
  DELETE_TOKEN_DONATOR: 'deleteTokenDonator',
  DELETE_TOKEN: 'deleteTokenById',

  // Channel Manager Service
  GET_CUR_ACC_PARTITIONED_CHANNELS: 'getCurrentAccountPartitionedChannels',
  UPDATE_PARTITIONED_CHANNEL: 'updatePartitionedChannel',
  UPDATE_PARTITIONED_CHANNEL_ONGOING: 'updatePartitionedChannelOngoing',

  // Hashtag Manager Service
  GET_CUR_ACC_CHANNEL_HASHTAGS: 'getCurrentAccountChannelHashtags',
  SAVE_OR_UPDATE_CHANNEL_HASHTAG: 'saveOrUpdateChannelHashtag',
  DELETE_CHANNEL_HASHTAG: 'deleteChannelHashtag',

  // Feature Test
  GET_USER_FEATURE_INFOS: 'getUserFeatureInfos',
  UPDATE_USER_FEATURE_INFOS: 'updateUserFeatureInfos',

  // AI Job
  GET_AI_JOB_CONTENT: 'getAiJobContent',
  GET_RECENT_AI_JOBS: 'getRecentAiJobs'
})

export default Type
